import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { authErrorMessage } from '../lib/authErrors';
import { TerminalSquare, Loader2 } from 'lucide-react';

const BG = 'https://images.unsplash.com/photo-1762279389042-9439bfb6c155?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxkYXJrJTIwYWJzdHJhY3QlMjB0ZWNobm9sb2d5JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3Nzc5MjI3MTF8MA&ixlib=rb-4.1.0&q=85';

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success('Giriş başarılı');
            nav('/');
        } catch (err) {
            toast.error(authErrorMessage(err, 'Giriş başarısız'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="min-h-screen w-full flex items-center justify-center relative"
            style={{ backgroundImage: `url(${BG})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
        >
            <div className="absolute inset-0 bg-slate-900/80 backdrop-blur-sm" />
            <div className="relative w-full max-w-md px-6">
                <div className="flex items-center gap-2 mb-8">
                    <TerminalSquare className="h-5 w-5 text-emerald-400" />
                    <span className="text-xs uppercase tracking-[0.25em] text-slate-300">Crypto Decision Support</span>
                </div>

                <div className="border border-slate-700 bg-slate-800 rounded-md p-6 sm:p-8">
                    <h1 className="text-2xl font-semibold tracking-tight text-slate-50 mb-1">Giriş Yap</h1>
                    <p className="text-sm text-slate-400 mb-6">Hesabına giriş yaparak tarama ve analiz ekranına devam et.</p>

                    <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
                        <div>
                            <Label htmlFor="email" className="text-xs text-slate-300 mb-1.5 block uppercase tracking-wider">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                data-testid="login-email-input"
                                className="bg-slate-900 border-slate-700 h-10 rounded-sm focus-visible:ring-1 focus-visible:ring-zinc-500"
                            />
                        </div>
                        <div>
                            <Label htmlFor="password" className="text-xs text-slate-300 mb-1.5 block uppercase tracking-wider">Şifre</Label>
                            <Input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                data-testid="login-password-input"
                                className="bg-slate-900 border-slate-700 h-10 rounded-sm focus-visible:ring-1 focus-visible:ring-zinc-500"
                            />
                        </div>
                        <Button
                            type="submit"
                            disabled={loading}
                            data-testid="login-submit-button"
                            className="w-full bg-emerald-500 text-white hover:bg-emerald-400 h-10 rounded-sm font-medium"
                        >
                            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Giriş Yap'}
                        </Button>
                    </form>

                    <div className="mt-6 pt-6 border-t border-slate-700/50 flex items-center justify-between text-sm">
                        <span className="text-slate-400">Hesabın yok mu?</span>
                        <Link to="/signup" className="text-slate-100 hover:text-white underline-offset-4 hover:underline" data-testid="signup-link">
                            Yeni hesap oluştur
                        </Link>
                    </div>
                </div>

                <p className="mt-6 text-[11px] text-slate-400 text-center leading-relaxed">
                    Bu platform yatırım tavsiyesi sunmaz. Üretilen tüm çıktılar olasılık ve risk çerçevesindedir.
                </p>
            </div>
        </div>
    );
}
